module.exports = __webpack_public_path__ + "img/home-soccer-icon-white.d6e3ff82.png";